import { Card, Tabs } from 'antd'
import { TabsProps } from 'antd/lib'

import { useLocales } from 'src/locales'

import { ClassifierElements, GeneralDetails } from '..'

export const ClassifiersDetails = () => {
  const { t } = useLocales()

  const tabItems: TabsProps['items'] = [
    {
      key: 'general',
      label: t('classifiers.general'),
      children: <GeneralDetails />
    },
    {
      key: 'elements',
      label: t('classifiers.elements'),
      children: <ClassifierElements />
    }
  ]

  return (
    <Card>
      <Tabs items={tabItems} />
    </Card>
  )
}
